import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Menggabungkan kelas kondisional lalu meluruhkan konflik Tailwind, sehingga
 * kelas dari props selalu menang atas kelas bawaan komponen - 
 * `cn('px-4', 'px-6')` menghasilkan `px-6`, bukan keduanya.
 */
export const cn = (...inputs) => twMerge(clsx(inputs));
